import { modifier } from 'ember-modifier';

// this code was pinched from https://github.com/elwayman02/ember-scroll-modifiers/pull/360
// Version 2.0.0 (the version it was merged into) https://github.com/elwayman02/ember-scroll-modifiers does not support node <v12.

export default modifier(function scrollIntoView(
  element,
  positional,
  named = {},
) {
  const { options, shouldScroll } = named;
  let hasBeenRemoved;

  const shouldScrollPromise = Promise.resolve(shouldScroll);

  shouldScrollPromise.then((shouldScrollValue) => {
    if (shouldScrollValue && element && !hasBeenRemoved) {
      element.scrollIntoView(options);
    }
  });

  return () => {
    hasBeenRemoved = true;
  };
});
